import { styled as R, Box as A } from "@mui/material";
import "../../../auth-lib/components/AccountHeader.js";
import "../../../auth-lib/components/AccountInfo.js";
import "../../../auth-lib/components/ApeironSsoRedirectFlow.js";
import "../../../auth-lib/components/ConnectWalletButton.js";
import "../../../auth-lib/components/PlayerIcon.js";
import "../../../auth-lib/components/SsoRedirectFlow.js";
import "../../../auth-lib/constants/apeironSso.js";
import "../../../auth-lib/contexts/AuthLibContext.js";
import "../../../auth-lib/contexts/LoginErrorContext.js";
import "@apollo/client";
import "../../../auth-lib/graphql/query/getOAuthLoginLink.js";
import "../../deserialize/yup/account.js";
import "../../graphql/client/loginClient.js";
import "../../deserialize/yup/page.js";
import * as i from "ramda";
import { useState as I, useCallback as a, useEffect as x } from "react";
import "../../constants/account.js";
import { useAccountContext as T } from "../../contexts/account/AccountContext.js";
import { useRouter as _ } from "next/router";
import "../../../download-lib/deserializes/yup/download.js";
import "../../contexts/config/ConfigContext.js";
import "query-string";
import "../../contexts/language/LanguageContext.js";
import "../../util/i18n/helper/locale.js";
import "path";
import "@tanstack/react-query";
import "jwt-decode";
import "universal-cookie";
import { getAccessToken as w } from "../../util/authenication/index.js";
import "react-cookie";
import P from "../../../auth-lib/hooks/useApeironSsoRedirect.js";
import S from "../share/generic/AnimatedBox.js";
import { RESTRICT_MODE as o } from "../../constants/layout.js";
import { Role as O } from "../../constants/role.js";
import { ROUTE as G } from "../../constants/route.js";
import { useMessageContext as y } from "../../contexts/share/MessageContext.js";
import B from "../../../ui-lib/components/MuiLoading.js";
import { useTranslation as M } from "react-i18next";
import { jsxs as j, Fragment as k, jsx as f } from "react/jsx-runtime";
const v = R(A)`
  align-items: center;
  background-color: #26282a;
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0px;
  position: fixed;
  top: 0px;
  width: 100vw;
  z-index: 1;
`, b = R(S)`
  align-items: center;
  background: linear-gradient(90deg, #333333 0%, #343434 35%, #445566 100%);
  display: flex;
  flex: 1;
  justify-content: center;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  white-space: pre-line;
`, Io = (E) => {
  const {
    children: N,
    restriction: d
  } = E, {
    t
  } = M(), [e, p] = I(o.WAITING), r = _(), {
    account: n,
    isLoggedIn: u
  } = T(), {
    setInfo: s
  } = y(), {
    jumpToSso: g
  } = P(), m = a((c) => {
    const l = i.pipe(i.split(/[?#]/), i.propOr("", "0")), L = i.propOr(O.Guest, l(c), d);
    n.role < L ? p(u ? o.BLOCK_SCREEN : o.PROMPT_LOGIN) : p(o.NONE);
  }, [n.role, u, d]);
  x(() => {
    const c = i.isNil(w()), l = n.role !== O.Guest;
    if (c || l)
      return m(r.asPath), r.events.on("routeChangeComplete", m), () => {
        r.events.off("routeChangeComplete", m);
      };
  }, [n, m, r.asPath, r.events]);
  const h = a(() => {
    s(null);
  }, [s]), C = a(() => {
    g({
      redirectUrl: window.location.href,
      ssoHandleUrl: `${window.location.origin}${G.CALLBACK_APEIRON_SSO}`
    });
  }, [g]);
  return x(() => {
    e === o.PROMPT_LOGIN && s({
      message: t("login_prompt.text"),
      cancel: t("common.cancel"),
      confirm: t("top_bar.login"),
      onConfirm: C,
      onCancel: h
    });
  }, [h, C, e, s, t]), /* @__PURE__ */ j(k, {
    children: [e === o.BLOCK_SCREEN && /* @__PURE__ */ f(b, {
      children: t("restricted.401")
    }), e === o.NONE && N, e === o.WAITING && /* @__PURE__ */ f(v, {
      children: /* @__PURE__ */ f(B, {
        loading: !0
      })
    })]
  });
};
export {
  Io as default
};
//# sourceMappingURL=EnoughRoleOnly.js.map
